/*
 * Created by guandong.ni on 17/10/27.
 * 将json转为url参数，可配合urlQuery.getAll() 修改 URL参数
 */
export function jsonToUrl(url, json) {
  let q = '';
  for (let k in json) {
    q += q ? '&' : '';
    q += k + '=' + json[k];
  }
  if (url.indexOf('?') > -1) {
    q = url + '&' + q;
  } else {
    q = url + '?' + q;
  }
  return q;
}
export function replaceUrl(url, label, value) {
  if (typeof value === 'object') {
    console.error('replaceUrl暂时只支持string');
    return '';
  }
  return url.replace(label, value);
}
export default jsonToUrl;



// WEBPACK FOOTER //
// ./src/component/common/jsonToUrl.js